<!--
 * @Author: zhaohaozhuang
 * @Date: 2022-12-14 17:11:04
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2023-05-09 16:24:22
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="page xm-page">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "xm-page"
};
</script>

<style lang='less' rel="stylesheet/less">
@import "../core/style.less";
@import "../core/mixins.less";

.xm-page {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #f4f6fa;
  // padding-bottom: 0.9rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.xm-page-header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  height: 0.88rem;
  width: 100%;
  line-height: 0.88rem;
  padding: 0rem 0.3rem;
}

.xm-page-header ~ .xm-page-content {
  top: 0.88rem;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue